import * as O from 'fp-ts/lib/Option'
import * as R from 'fp-ts/lib/ReadonlyRecord'
import { pipe } from 'fp-ts/lib/function'

export const lookup = (
  key: string,
  obj: Readonly<Record<string, unknown>>
): O.Option<unknown> => pipe(obj, R.lookup(key), O.chain(O.fromNullable))
